export function fromFrontToBackPackage(photographPackage) {
    return {
        ...photographPackage,
        unit_prices: photographPackage.unit_prices.map((unitPrice) => {
            return {
                ...unitPrice,
                unit_price: Number((unitPrice.unit_price * 100).toFixed(0))
            }
        })
    }
}


export function fromBackToFrontPackage(photographPackage) {
    return {
        ...photographPackage,
        unit_prices: photographPackage.unit_prices.map((unitPrice) => {
            return {
                ...unitPrice,
                unit_price: (unitPrice.unit_price / 100).toFixed(2)
            }
        })
    }
}

export function findCorrespondingUnitPrice(packagee, nbPhotos) {
    return [...packagee.unit_prices].sort((up1, up2) => up2.nb_photos - up1.nb_photos).find(price => {
        return price.nb_photos <= nbPhotos
    })
}
